const agregarDireccion = objeto => {
    return {
        type: 'agregarDireccion',
        payload: objeto
    }
}

const actualizarDireccion = objeto => {
    return {
        type: 'actualizarDireccion',
        payload: objeto
    }
}

const removeAddress = payload => {
    return {
        type: "removeAddress",
        payload
    }
}


module.exports = {
    agregarDireccion,
    actualizarDireccion,
    removeAddress
}